import { render, staticRenderFns } from "./VPIIntroduction.vue?vue&type=template&id=0b74afa1&scoped=true&"
import script from "./VPIIntroduction.vue?vue&type=script&lang=js&"
export * from "./VPIIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74afa1",
  null
  
)

export default component.exports